import { Turnstile } from "@marsidev/react-turnstile";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { envChangeType, getLang } from "../../plugins/utils";
import CustomModal from "../CustomModal";
import styles from "./style.module.scss";

const CloudflareAuth = ({
  theme,
  style,
  isModalVisible,
  setIsModalVisible,
  loginFailTime = null,
  setCloudflareToken,
}) => {
  const { t } = useTranslation();
  const turnstileRef = useRef();
  // const pathName = window.location.pathname;
  // useEffect(() => {
  //   if (turnstileRef.current) {
  //     if (pathName === "/signin") {
  //       switch (loginFailTime) {
  //         case 0:
  //           return;
  //         case 1:
  //           console.log(turnstileRef);
  //           turnstileRef?.current.render();
  //           turnstileRef?.current.execute();
  //           return;
  //         default:
  //           console.log(123);
  //           setCloudflareToken("");
  //           turnstileRef?.current.reset();
  //           return;
  //       }
  //     } else {
  //       console.log(456);
  //       turnstileRef?.current.render();
  //       turnstileRef?.current.execute();
  //     }
  //   }
  // }, [pathName, loginFailTime, setCloudflareToken, turnstileRef]);

  useEffect(() => {
    switch (loginFailTime) {
      case 0:
        return;
      case 1:
        // turnstileRef?.current.render();
        // turnstileRef?.current.execute();
        return;
      default:
        setCloudflareToken("");
        turnstileRef?.current.reset();
        return;
    }
  }, [loginFailTime, setCloudflareToken]);

  return (
    <div>
      <Turnstile
        className={styles.cloudflare}
        ref={turnstileRef}
        siteKey={envChangeType("REACT_APP_LOGIN_CLOUDFLARE_KEY")}
        onSuccess={setCloudflareToken}
        onError={() =>
          setTimeout(() => {
            turnstileRef?.current.reset();
            // turnstileRef?.current.render();
            // turnstileRef?.current.execute();
          }, [30000])
        }
        onExpire={() => {
          // setCloudflareToken("");
          turnstileRef?.current.reset();
          // turnstileRef?.current.render();
          // turnstileRef?.current.execute();
        }}
        options={{
          language: getLang(),
          retry: "never",
          theme: theme,
          // action: "login",
          // execution: "execute",
          // appearance: "execute",
        }}
        scriptOptions={{ async: false, defer: false }}
        style={{ width: "100%", ...style }}
      />
      <CustomModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        content={t("errorMessage.notPassCloudflare")}
        needIcon={true}
        okBtnText={t("normal.confirm")}
        isHaveCancel={false}
      />
    </div>
  );
};

export default CloudflareAuth;
